//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import IconBookmark from 'vue-material-design-icons/Bookmark.vue'
import IconBookmarkOutline from 'vue-material-design-icons/BookmarkOutline.vue'

const CREATE_USER_ARTICLE = gql`
  mutation ($data: UserArticleInput) {
    upsertUserArticle(data: $data) {
      article {
        id
      }
    }
  }
`

const DELETE_USER_ARTICLE = gql`
  mutation ($data: UserArticleInput) {
    deleteUserArticle(data: $data) {
      article {
        id
      }
    }
  }
`

export default {
  components: { IconBookmark, IconBookmarkOutline },
  props: {
    article: {
      type: Object,
      required: true
    },
    hasLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bookmarkArticleIds() {
      return this.$store.get('bookmark/articleIds') || []
    },
    isBookmarked() {
      return this.bookmarkArticleIds.find((x) => x === this.article?.id) != null
    },
    bookmarkClassIcon() {
      return this.isBookmarked ? 'BookmarkIcon' : 'BookmarkOutlineIcon'
    },
    account() {
      return this.$store.get('user/user') || null
    }
  },
  methods: {
    onBookmarkClicked() {
      try {
        let articleIds = this.bookmarkArticleIds
        this.$apollo
          .mutate({
            mutation: this.isBookmarked ? DELETE_USER_ARTICLE : CREATE_USER_ARTICLE,
            variables: { data: { articleId: this.article.id } }
          })
          .catch(() => {
            this.$buefy.notification.open({
              duration: 5000,
              message: this.$t('article_binder.error_not_binded'),
              type: 'is-danger'
            })
          })

        if (this.isBookmarked) {
          articleIds = this.bookmarkArticleIds.filter((x) => x !== this.article.id)
        } else {
          articleIds.push(this.article.id)
        }

        this.$store.set('bookmark/articleIds', articleIds)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
